import { PrintableRootPage } from 'components/page/page-2';
import {
  PatientInfoContext,
  useGetPatientInfo
} from 'features/patient/_utils/patient-info/hook-context-patientinfo';
import { useParams } from 'react-router-dom';
import { DisplayDiscovery } from './components/display-discovery';

export function PatientHomeClinician() {
  const { patientId } = useParams<{ patientId: string }>();

  const { state: patientInfo, dispatch: patientInfoDispatch, refetch } =
    useGetPatientInfo(patientId);

  return (
    <PrintableRootPage
      title="Test-Taker Home"
      hideTitle={!!patientInfo.patient.id}
      hasError={patientInfo.hasError}
    >
      <PatientInfoContext.Provider
        value={{
          patientInfo,
          dispatch: patientInfoDispatch,
          refetch
        }}
      >
        <DisplayDiscovery />
      </PatientInfoContext.Provider>
    </PrintableRootPage>
  );
}
